/**
 * Font disponibili per ruolo tipografico (titoli/corpo/accento), scelti da
 * admin (Impostazioni → Tipografia). I primi 3 sono quelli già caricati via
 * Google Fonts (index.html); "Modica Pro" è il webfont di brand self-hosted
 * (vedi @font-face in theme-morettino-caffepalermo.css, file in public/fonts/).
 * I `value` corrispondono esattamente ai default del tema — scegliere la
 * prima voce per ogni ruolo equivale a "nessuna modifica".
 */
export const FONT_LIBRARY = [
  { value: "'Quicksand', 'Inter', serif", label: 'Quicksand' },
  { value: "'Inter', 'Helvetica Neue', sans-serif", label: 'Inter' },
  { value: "'Cormorant', serif", label: 'Cormorant' },
  { value: "'Modica Pro', 'Inter', sans-serif", label: 'Modica Pro (brand)' },
];

const ROLE_TO_CSS_VAR = {
  heading: '--font-heading',
  body: '--font-body',
  accent: '--font-accent',
};

/** Applica la scelta admin sovrascrivendo le custom property del tema su :root — vince sempre sul default per specificità (stile inline). */
export function applyTypography(typography = {}) {
  const root = document.documentElement;
  for (const [role, cssVar] of Object.entries(ROLE_TO_CSS_VAR)) {
    const value = typography[role];
    if (value) root.style.setProperty(cssVar, value);
  }
}
